import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { cn } from "@/lib/utils";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function TheSjdesignEthos() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll();
  const {
    ref: imgRef,
    isVisible: isImgVisible
  } = useRevealOnScroll();
  return <section data-section-id="46105" id="the-mission-power-reclamation" className="dark bg-[#121214] text-foreground relative w-full overflow-hidden">
      <div className="grid min-h-[800px] w-full grid-cols-1 lg:grid-cols-[60%_40%]">
        {}
        <div className="relative flex flex-col justify-center px-6 py-20 sm:px-12 lg:px-20 xl:px-32">
          {}
          <div className="text-primary/5 font-mono absolute -top-20 -left-10 select-none text-[15rem] leading-none font-bold opacity-10 mix-blend-overlay lg:text-[25rem]" aria-hidden="true">
            01
          </div>

          <div ref={textRef} className={cn("relative z-10 max-w-2xl transition-all duration-1000 ease-out", isTextVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0")}>
            <span className="text-primary mb-6 block text-sm font-mono tracking-widest uppercase">
              Core Objective
            </span>
            <h2 className="font-sans mb-8 text-4xl font-bold leading-tight tracking-wider text-white uppercase sm:text-5xl lg:text-6xl">
              The Mission: <br />
              <span className="text-primary">
                Power Reclamation
              </span>
            </h2>

            <div className="space-y-6 text-lg leading-relaxed">
              <p className="font-sans text-muted-foreground font-light">
                Exergy Systems operates at the intersection of autonomic AI and 
                industrial thermodynamics. We specialize in Exergy Recovery for 
                mission-critical Data Centers and C&I facilities, engineering 
                systems that eliminate thermal waste at the source.
              </p>
              <p className="font-mono text-primary text-sm tracking-tight border-l border-primary/20 pl-6 py-2">
                DIRECTIVES: [01] AUTONOMIC THERMAL CONTROL 
                ELIMINATION 
                POWER RECLAMATION.
              </p>
            </div>

            <div className="mt-10 flex flex-wrap gap-4">
              <Button asChild variant="outline" className="border-primary/40 hover:bg-primary/10 hover:text-primary h-12 rounded-none border px-8 text-base transition-colors duration-300 uppercase tracking-widest font-mono">
                <Link to="/ExergyAuditPage">
                  Request Exergy Audit
                </Link>
              </Button>
              <Button asChild variant="link" className="text-primary hover:text-white h-12 px-4 text-base decoration-1 underline-offset-4 transition-colors duration-300 uppercase tracking-widest font-mono">
                <Link to="/TechnicalSolutionPage" className="group flex items-center gap-2">
                  Technical Solution
                  <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1" />
                </Link>
              </Button>
            </div>
          </div>
        </div>

        {}
        <div className="relative h-[500px] w-full overflow-hidden lg:h-auto">
          <div ref={imgRef} className={cn("absolute inset-0 h-full w-full transition-all duration-1000 ease-out", isImgVisible ? "scale-100 opacity-100" : "scale-110 opacity-0")}>
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1598652/img/architectural_detail_marble_wood.png" alt="High-contrast architectural stone structure with sharp geometric shadows" className="h-full w-full object-cover object-center grayscale contrast-125" />
            {}
            <div className="bg-background/20 absolute inset-0 mix-blend-multiply" />
          </div>
        </div>
      </div>
    </section>;
}